angular.module('app').controller('PrivacyPolicyModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', 'ConsentService', 'LocalStorageRepository',
        function ($scope, $modalInstance, $sce, ConsentService, LocalStorageRepository) {
            'use strict';

            $scope.loading = true;
            var loginUserId = LocalStorageRepository.getUserID();

            function loadPrivacyPolicy() {
                $scope.loading = true;
                $scope.removeHttpError();

                if (loginUserId){
                    ConsentService
                        .getPrivacyPolicyUrl()
                        .then(function (privacyPolicyUrl) {
                            $scope.privacyPolicyUrl = privacyPolicyUrl;
                        })
                        .catch(function (response) {
                            $scope.addHttpError(response);
                        })
                        .finally(function() {
                            $scope.loading = false;
                        });
                } else {
                    $scope.loading = false;
                }
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;

            loadPrivacyPolicy();
        }]);